import { render, staticRenderFns } from "./leave-case-manage-pending.vue?vue&type=template&id=45c2bcbd&scoped=true"
import script from "./leave-case-manage-pending.vue?vue&type=script&lang=ts"
export * from "./leave-case-manage-pending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2bcbd",
  null
  
)

export default component.exports